// append to external links only
$.expr[':'].external = function(obj){
  return !obj.href.match(/^mailto\:/)
  && (obj.hostname != location.hostname)
  && !obj.href.match(/^javascript\:/)
  && !obj.href.match(/^$/)
  && !obj.href.match(/^tel\:/)
};
$('a:external').attr('target', '_blank');
$('a:external').append('<span class="external-link">&nbsp;<i class="fas fa-external-link-alt"></i><span>');